import injectSheet from 'react-jss';

import greetingStyles from '-/styles/sections/greeting';
import {forgetOffer} from '-/util/util';

const NotMe = props => {
    const {classes = {}} = props;
    const onClick = e => {
        e.preventDefault();

        forgetOffer();
    };

    return (
        <p className={classes.p}>
            <a
                className={classes.notMe}
                href="#"
                onClick={onClick}>
                this is not me
            </a>
        </p>
    );
};

export default injectSheet(greetingStyles)(NotMe);